import { Typography, makeStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { ITheme, colours } from "../constants/theme";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";

export const DropdownMenuButton = (props: any) => {
  const classes = useStyles();
  const { title, selected, value } = props;
  return (
    <Button
      id="basic-button"
      aria-controls="basic-menu"
      aria-haspopup="true"
      style={{
        backgroundColor: selected ? colours.highEmphasis04 : undefined,
      }}
      onClick={() => props.handleClick(value)}
      className={classes.button}
    >
      <Typography
        variant="body2"
        component="span"
        color={selected ? "primary" : "textPrimary"}
        className={classes.printButtonText}
      >
        {title}
      </Typography>
    </Button>
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  button: {
    justifyContent: "flex-start",
    width: "100%",
    minHeight: "40px",
    marginTop: "4px",
    marginBottom: "4px",
    paddingLeft: "12px",
    paddingRight: "12px",
    borderRadius: "8px",
    ...textButtonHoverAndActive
  },
  printButtonText: {
    textTransform: "none",
    fontWeight: 600,
  },
}
));
